import Chevron from '../Chevron/Chevron';
import MerchantProfilePicture from '../MerchantProfilePicture/MerchantProfilePicture';
import { LIGHT_GRAY } from '../../styles/colors';
import {
  Container,
  BackgroundContainer,
  BodyContainer,
  ParticlesContainer,
  TextContainer,
  TitleText,
  SubtitleText,
  FooterContainer
} from './MerchantInformationCard.styles';
import Particles from '../Particles/Particles';

export type MerchantInformationCardProps = {
  title?: string;
  subtitle?: string;
  url?: string;
  onClick: () => void;
  defaultTitle: string;
  defaultSubtitle: string;
  editInformationLabel: string;
  fillInformationLabel: string;
};

const MerchantInformationCard = ({
  title,
  subtitle,
  url,
  onClick,
  defaultTitle,
  defaultSubtitle,
  editInformationLabel,
  fillInformationLabel,
}: MerchantInformationCardProps) => {
  const hasData = !!(title || subtitle);

  return (
    <Container>
      <Body
        title={title}
        subtitle={subtitle}
        url={url}
        defaultTitle={defaultTitle}
        defaultSubtitle={defaultSubtitle}
      />
      <Footer
        hasData={hasData}
        onClick={onClick}
        editInformationLabel={editInformationLabel}
        fillInformationLabel={fillInformationLabel}
      />

      <BackgroundContainer>
        <CardBackground />
      </BackgroundContainer>
    </Container>
  );
};

export default MerchantInformationCard;

const Body = ({
  title,
  subtitle,
  url,
  defaultTitle,
  defaultSubtitle,
}: {
  title?: string;
  subtitle?: string;
  url?: string;
  defaultTitle: string;
  defaultSubtitle: string;
}) => {
  const hasData = !!(title || subtitle);

  return (
    <BodyContainer $hasData={hasData}>
      {hasData && (
        <ParticlesContainer>
          <Particles />
        </ParticlesContainer>
      )}
      <MerchantProfilePicture
        backgroundColor={hasData ? LIGHT_GRAY : undefined}
        url={url}
      />
      <TextContainer $hasData={hasData}>
        <TitleText>
          {title || defaultTitle}
        </TitleText>
        <SubtitleText $hasData={hasData}>
          {subtitle || defaultSubtitle}
        </SubtitleText>
      </TextContainer>
    </BodyContainer>
  );
};

const Footer = ({
  hasData = false,
  onClick,
  editInformationLabel,
  fillInformationLabel,
}: {
  hasData?: boolean;
  onClick: () => void;
  editInformationLabel: string;
  fillInformationLabel: string;
}) => {
  return (
    <FooterContainer $hasData={hasData} onClick={onClick}>
      <span>{hasData ? editInformationLabel : fillInformationLabel}</span>
      <Chevron strokeWidth={1} color={hasData ? 'white' : 'black'} />
    </FooterContainer>
  );
};

const CardBackground = () => {
  return (
    <svg width="426" height="426" viewBox="0 0 426 426" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="213" cy="213" r="213" fill="url(#paint0_linear_13845_15719)"/>
      <circle cx="170" cy="170" r="170" fill="url(#paint1_linear_13845_15719)"/>
      <circle cx="170" cy="170" r="169.5" stroke="#4542D6" strokeOpacity="0.75"/>
      <circle cx="190" cy="170" r="170" fill="url(#paint2_linear_13845_15719)"/>
      <circle cx="137.5" cy="137.5" r="137.5" fill="url(#paint3_linear_13845_15719)"/>
      <circle cx="101" cy="101" r="101" fill="url(#paint4_linear_13845_15719)"/>
      <defs>
        <linearGradient id="paint0_linear_13845_15719" x1="279.5" y1="213" x2="361.5" y2="375" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4B1EB9"/>
          <stop offset="1" stopColor="#7717DD"/>
        </linearGradient>
        <linearGradient id="paint1_linear_13845_15719" x1="159.491" y1="134.145" x2="257.164" y2="323.309" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F38D2"/>
          <stop offset="1" stopColor="#7717DD"/>
        </linearGradient>
        <linearGradient id="paint2_linear_13845_15719" x1="210.5" y1="170" x2="331" y2="296" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4B1EB9"/>
          <stop offset="1" stopColor="#7717DD"/>
        </linearGradient>
        <linearGradient id="paint3_linear_13845_15719" x1="129" y1="108.5" x2="211" y2="229" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B28D7"/>
          <stop offset="0.5" stopColor="#5B28D7"/>
          <stop offset="1" stopColor="#7717DD"/>
        </linearGradient>
        <linearGradient id="paint4_linear_13845_15719" x1="95" y1="125.5" x2="117" y2="202" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F38D2"/>
          <stop offset="0.5" stopColor="#791DDC"/>
          <stop offset="1" stopColor="#791DDC"/>
        </linearGradient>
      </defs>
    </svg>
  );
};
